// import plugins from gsap/dist/* (UMD builds) — the root paths (gsap/ScrollTrigger)
// are ESM and crash Next's server-side page-data collection with
// "Cannot use import statement outside a module"
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'
import { ScrollToPlugin } from 'gsap/dist/ScrollToPlugin'
import { Observer } from 'gsap/dist/Observer'
import { Flip } from 'gsap/dist/Flip'
import { SplitText } from 'gsap/dist/SplitText'
import { ScrambleTextPlugin } from 'gsap/dist/ScrambleTextPlugin'

// single registration point for the whole app (client only)
if (typeof window !== 'undefined') {
  gsap.registerPlugin(ScrollTrigger, ScrollToPlugin, Observer, Flip, SplitText, ScrambleTextPlugin)
}

export const prefersReducedMotion = () =>
  typeof window !== 'undefined' && window.matchMedia('(prefers-reduced-motion: reduce)').matches

export { gsap, ScrollTrigger, ScrollToPlugin, Observer, Flip, SplitText }


// added motion